import { useEffect, useLayoutEffect, useRef } from 'react';

const useInterval = (callback: () => void, delay: number) => {
	const savedCallback = useRef(callback);

	// Remember the latest callback if it changes.
	useLayoutEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		// Don't schedule if no delay is specified.
		// To turn off the useInterval use delay = 0.
		if (!delay) {
			return undefined;
		}

		const id = setInterval(() => savedCallback.current(), delay);

		return () => clearInterval(id);
	}, [delay]);
};

export default useInterval;
